import React, { useEffect } from "react";
import {
  Avatar,
  Button,
  Card,
  Col,
  ColorPicker,
  Descriptions,
  Row,
  Space,
} from "antd";
import { useNavigate } from "react-router";
import { ReactComponent as ColorSvg } from "../../../assets/images/description/Color Palette.svg";
import { useDispatch, useSelector } from "react-redux";
import { getBrandingData } from "../../../redux/action/branding/brandingAction";
import { UserOutlined } from "@ant-design/icons";
import CommonUpload from "../../../components/common/upload-image";

const Branding = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBrandingData());
  }, []);

  const datas = useSelector((store) => store.getBrandingData?.data);
  const { isLoading } = useSelector((store) => store.getBrandingData);

  const imgUrl = `${process.env.REACT_APP_API_IMG_URI}/${datas?.logo}`;

  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <ColorSvg /> Primary Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={datas?.primary_color ?? "#000000"} disabled />
          <span>{datas?.primary_color ?? "#000000"}</span>
        </div>
      ),
      // span: 2,
    },
    {
      key: "2",
      label: (
        <>
          <ColorSvg /> Primary Text Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={datas?.font_color ?? "#000000"} disabled />
          <span>{datas?.font_color ?? "#000000"}</span>
        </div>
      ),
      // span: 2,
    },
    {
      key: "2",
      label: (
        <>
          <ColorSvg /> Background Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={datas?.bg_color ?? "#000000"} disabled />
          <span>{datas?.bg_color ?? "#000000"}</span>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <ColorSvg /> Secondary Text Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={datas?.text_color ?? "#000000"} disabled />
          <span>{datas?.text_color ?? "#000000"}</span>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <ColorSvg /> Button Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={datas?.btn_color ?? "#000000"} disabled />
          <span>{datas?.btn_color ?? "#000000"}</span>
        </div>
      ),
    },

    {
      key: "2",
      label: (
        <>
          <ColorSvg /> Button Text Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={datas?.btn_text_color ?? "#000000"} disabled />
          <span>{datas?.btn_text_color ?? "#000000"}</span>
        </div>
      ),
    },
    {
      key: "11",
      label: (
        <>
           <ColorSvg /> Default Language
        </>
      ),
      children: datas?.default_language === 1 ? "English" : datas?.default_language === 2 ? "Spanish" : datas?.default_language === 3 ? "Portuguese" :  "N/A",
    },
    
  ];
  const initialFileList = imgUrl
    ? [
        {
          uid: "-1",
          name: "logo",
          url: imgUrl,
        },
      ]
    : [];
  return (
    <>
      <div className="addBtnBx dflex">
        <div className="tableHeading">View Branding Details</div>
        <Space>
          <Button type="primary" onClick={() => navigate("edit-branding")}>
            Edit Details
          </Button>
        </Space>
      </div>
      <Card loading={isLoading}>
        <Row gutter={16}>
          <Col xs={24} sm={24}>
            <div className="branding">
              {imgUrl ? (
                <CommonUpload
                  maxFiles={1}
                  fileLimitSize={2}
                  // setFieldValue={(url) => handleUploadSuccess("logo", url)}
                  fileList={initialFileList}
                  showRemoveIcon={false}
                />
              ) : (
                <div>
                  <Avatar size={103} icon={<UserOutlined />} />
                </div>
              )}

              <div className="customDescription imgRightSideBx">
                <Descriptions
                  className="custom_descriptions"
                  layout="vertical"
                  items={basicInfo_details}
                  size="small"
                  // column={{ xs: 1, sm: 2, md: 4 }}
                  column={4}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default Branding;
